import { Box, Button, Stack, TextField, Typography } from "@mui/material";
import classNames from "classnames/bind";
import React, { useEffect, useState } from "react";
import styles from "./index.module.css";

const PosPopUp = ({ ocpPos, cancel, handleInvite }) => {
  const cx = classNames.bind(styles);
  const all_pos = ['CEO', 'CTO', 'CFO', 'CMO', 'CDO']
  const positions = [];
  const [chosen, setChosen] = useState("");
  for (const pos of all_pos) {
    if (!ocpPos.includes(pos)) positions.push(pos)
  }

  const handlePosClicked = (pos) => {
    setChosen(pos);
  }

  return (
    <Box className={cx("modal")}>
      <Box className={cx("pop-up-box")}>
        <Typography className={cx("text")}>請選擇想邀請的職位</Typography>
        <Stack
          direction="row"
          spacing={2}
          justifyContent="center"
        >
          {
            positions.map((item) => {
              return (
                <Button style={{
                  background: chosen === item ? "#ffce26" : "white"
                }} className={cx("pos-btn")} onClick={() => { handlePosClicked(item) }}>
                  <Typography fontSize="0.5em" color="#575757">
                    {item}
                  </Typography>
                </Button>
              );
            })
          }
        </Stack>
        <Stack
          direction="row"
          justifyContent="flex-end"
          width="100%"
          marginTop="5%"
          marginRight="13%"
          spacing={2}
        >
          <Button className={cx("cancel-btn")} onClick={cancel}>
            <Typography fontSize="0.5em" color="#575757">
              取消
            </Typography>
          </Button>
          <Button className={cx("confirm-btn")} onClick={() => { handleInvite(chosen); cancel(); }}>
            <Typography fontSize="0.5em" color="#575757">
              確定
            </Typography>
          </Button>
        </Stack>
      </Box>
    </Box>
  );
};

export default PosPopUp;
